/* ----------------------------------------------------------------------------
js entry point
---------------------------------------------------------------------------- */
import animateOnScroll from './_elements/animate-on-scroll.js';
import cosmicBackground from './_elements/cosmic-background.js';
import homepageSearch from './_elements/homepage-search.js';
import numberComparison from './_elements/number-comparison.js';
import PopoverMenu from './_elements/popover-menu.js';
import RandomShapes from './_elements/random-shapes.js';
import readingFinder from './_elements/reading-finder.js';
import reflectionJournal from './_elements/reflection-journal.js';
import SmallDetails from './_elements/small-details.js';
import softNavigation from './_elements/soft-navigation.js';
import ThemePicker from './_elements/theme-picker.js';

function initPage() {
	homepageSearch();
	numberComparison();
	readingFinder();
	reflectionJournal();
}

cosmicBackground();
softNavigation();
initPage();
window.addEventListener('sacred-scribes:navigate', initPage);
